let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1cgn8")).then(() => parcelRequire('3CfKB'));